export const isExpired = (expirationDate?: string): boolean => {
  if (!expirationDate) return false;

  const expDate = new Date(expirationDate);
  const currentDate = new Date();

  return currentDate > expDate;
};

export const getTimeUntilExpiration = (expirationDate?: string): string => {
  if (!expirationDate) return '';

  const expDate = new Date(expirationDate);
  const currentDate = new Date();
  const diffMs = expDate.getTime() - currentDate.getTime();

  if (diffMs <= 0) return '';

  const totalSeconds = Math.floor(diffMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);

  if (hours > 0) {
    return `${hours}h ${minutes}min`;
  }

  return `${minutes}min`;
};
